module.exports = __webpack_public_path__ + "img/banner-principal.d1ec55a6.png";